import axios from "axios";

function errorRedirect(msg) {
  console.log('API Response Error:', msg);
}

export function Getdata(url, config = {}) {
  let header = config;
  if (!("headers" in header)) {
    header = Object.assign(
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
      header
    );
  }
  const windowUrl = window.location.href;
  const hostname = new URL(windowUrl).hostname; // "jay.localhost"
  const parts = hostname.split(".");
  const subDomain = parts.length > 1 ? parts[0] : null;
  console.log('subDomain===>: ', process.env.REACT_APP_MARKETING_URL);
  if (!subDomain) {
    window.location.href = process.env.REACT_APP_MARKETING_URL;
  }

  url = url.replace("subdomain", `${subDomain}/`);
  console.log('url: ', url);
  return new Promise((resolve, reject) => {
    axios
      .get(url, header)
      .then((response) => {
        console.log("response123", response);
        response.data.message =
          response.data.message === "Authorization required"
            ? "Under Development..."
            : response.data.message;

        if (
          ["Unauthorized request", "You are already logged in on another device."].includes(
            response.data.message
          ) || response.data.status === 400
        ) {
          setTimeout(() => {
            console.log("window.location.href", window.location.href);
            window.location.href = "/";
          }, 800);
        }

        resolve(response.data);
      })
      .catch((e) => {
        console.log('e: ', e);
        if (e?.status === 404) {
          window.location.href = process.env.REACT_APP_MARKETING_URL;
        }
        e.message =
          e.message === "Network Error"
            ? "Something went wrong!!!"
            : e.message;
        errorRedirect(e.message);
        reject(e);
      });
  });
}